import { render, staticRenderFns } from "./dept.vue?vue&type=template&id=54af8a75&scoped=true&"
import script from "./dept.vue?vue&type=script&lang=js&"
export * from "./dept.vue?vue&type=script&lang=js&"
import style0 from "./dept.vue?vue&type=style&index=0&id=54af8a75&lang=less&scoped=true&"
import style1 from "./dept.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54af8a75",
  null
  
)

export default component.exports